import { authHeader } from './session';
import { getUrl } from './connection';

import { alert } from './stores/alert';
import { loading } from './stores/loading';

import { translate } from './i18n';

import { fetchJson } from './fetchData';

const getImages = async ({ start = 0, limit = null } = {}) => {
    const [url, method] = await getUrl('listimages');

    loading.newLoading();
    try {
        const response = await fetch(url, {
            method,
            headers: {
                'Content-Type': 'application/json; charset=utf-8',
                ...authHeader()
            }
        });
        if (response.status === 200) {
            const images = await response.json();
            return images.data;
        }
    }
    catch (e) {
        alert.newAlert({ message: translate('images.errors.other') + ": " + e.message, type: 'error' });
    }
    finally {
        loading.removeLoading();
    }
    return null;
}

const getImageUrl = (imageData) => {
    return imageData?.id && `/api/v1/image/data/${imageData.id}` || null;
}

// TODO: Eliminar lazy y lazyAll, porque se va a sustituir por loading="lazy" en el HTML
const lazy = (node, params) => {
	function observation(entries) {
		if(!entries[0].isIntersecting) return;
		node.setAttribute('alt', 'A cute dog')
		// node.setAttribute('src', node.getAttribute('data-src'))
		node.src = node.dataset.src;
		observer.unobserve(node)		
	} 
	
	const observer = new IntersectionObserver(observation, params);
	
	observer.observe(node)		
	
	return {
		onDestroy() {
			observer.unobserve(node)		
		}
	}
}
 
const lazyAll = (node, params) => {
	function observation(entries) {
		entries.forEach(entry => {
			if(!entry.isIntersecting) return;
			const { target } = entry;
			target.setAttribute('alt', 'A lazy dog')
			target.setAttribute('src', target.dataset.src)
			observer.unobserve(target)
		})
	} 
	
	const observer = new IntersectionObserver(observation, params);
	
	const imgs = node.querySelectorAll('img');
	imgs.forEach(img => observer.observe(img));
	
	return {
		onDestroy() {
			imgs.forEach(img => observer.unobserve(img));
		}
	}
}

const prepareMetadataParameter = (metadata) => {
	metadata = metadata ?? "";
	metadata = metadata.split(",");
	metadata = metadata.map(m => m.trim());
	return metadata;
}

const uploadImage = async ({ name, file, fileImageData, metadata }) => {
	const mime = file.type;
	metadata = prepareMetadataParameter(metadata);
	const data = fileImageData.replace(/^data:image\/(png|jpg|jpeg);base64,/, "");

	const result = await fetchJson({
		endpoint: 'saveimage',
		params: {
			name,
			mime,
			metadata,
			data
		},
		customErrorString: translate('images.errors.upload')
	});
	return result.data;
}

const editImageData = async ({ id, name, metadata }) => {
	metadata = prepareMetadataParameter(metadata);
	const result = await fetchJson({
		endpoint: 'updateimage',
		params: {
			id,
			name,
			metadata
		},
		customErrorString: translate('images.errors.update')
	});
	return result.data;
};

const deleteImage = async (id) => {
	const result = await fetchJson({
		endpoint: 'removeimage',
		params: {
			id
		},
		customErrorString: translate('images.errors.delete')
	});
	return result.data;
};

// Devuelve true si la imagen está siendo utilizada por algún recurso
const isInUse = async (id) => {
	const result = await fetchJson({
		endpoint: 'imagedependencies',
		params: {
			id
		},
		customErrorString: translate('images.errors.noSuchImage')
	});
	return result.data?.length > 0 || false;
}

export { getImages, getImageUrl, lazy, lazyAll, uploadImage, editImageData, deleteImage, isInUse }